"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEventProperties = exports.buildSearchParams = exports.generateSlug = exports.extractEventProperties = void 0;
var constants_1 = require("../constants");
var extractEventProperties = function (currentRoute, store, locale) {
    var _a, _b;
    var currentRouteParams = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.params;
    var isCategory = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink)
        ? ((_a = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink) === null || _a === void 0 ? void 0 : _a.split('/').length) === 1
        : false;
    var isSubCategory = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink)
        ? ((_b = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.permalink) === null || _b === void 0 ? void 0 : _b.split('/').length) > 1
        : false;
    var extractPageTypeFromWebViewPath = (currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.webviewPath) &&
        constants_1.pageTypes.find(function (item) { var _a, _b; return item.includes((_b = (_a = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.webviewPath) === null || _a === void 0 ? void 0 : _a.replace('/', '')) !== null && _b !== void 0 ? _b : ''); });
    var trackingParams = currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.trackingParams;
    var properties = __assign(__assign(__assign(__assign(__assign({ store: store, locale: locale, page_type: trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.page_type }, ((currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.slug) && {
        slug: currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.slug,
        product_sku: currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.sku,
        page_type: constants_1.PageType.Pdp,
    })), ((trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.term) && {
        term: trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.term,
        page_type: constants_1.PageType.Search,
    })), (isCategory && {
        category_name: currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.title,
        page_type: constants_1.PageType.Category,
    })), (isSubCategory && {
        subcategory_name: trackingParams === null || trackingParams === void 0 ? void 0 : trackingParams.subCategoryTitle,
        page_type: constants_1.PageType.SubCategory,
    })), (extractPageTypeFromWebViewPath && {
        page_type: extractPageTypeFromWebViewPath,
        slug: currentRouteParams === null || currentRouteParams === void 0 ? void 0 : currentRouteParams.slug,
    }));
    return properties;
};
exports.extractEventProperties = extractEventProperties;
var generateSlug = function (screenViewProperties, fallbackSlug) {
    var _a;
    var customSlugProperties = (_a = {},
        _a[constants_1.PageType.Home] = '',
        _a[constants_1.PageType.Deals] = 'deals',
        _a[constants_1.PageType.HowItWorks] = 'how-it-works',
        _a[constants_1.PageType.Category] = (screenViewProperties === null || screenViewProperties === void 0 ? void 0 : screenViewProperties.category_name) || '',
        _a[constants_1.PageType.SubCategory] = (screenViewProperties === null || screenViewProperties === void 0 ? void 0 : screenViewProperties.subcategory_name) || '',
        _a[constants_1.PageType.Pdp] = (screenViewProperties === null || screenViewProperties === void 0 ? void 0 : screenViewProperties.slug) || '',
        _a[constants_1.PageType.Search] = 'search',
        _a['favorite'] = 'favorites',
        _a);
    if (fallbackSlug) {
        for (var _i = 0, pageTypes_1 = constants_1.pageTypes; _i < pageTypes_1.length; _i++) {
            var pageType_1 = pageTypes_1[_i];
            customSlugProperties[pageType_1.toLowerCase()] = fallbackSlug;
        }
    }
    var pageType = (screenViewProperties === null || screenViewProperties === void 0 ? void 0 : screenViewProperties.page_type) || '';
    var slugFromPageName = fallbackSlug && customSlugProperties[fallbackSlug.toLowerCase()];
    var customSlugValue = pageType
        ? customSlugProperties[pageType]
        : slugFromPageName !== null && slugFromPageName !== void 0 ? slugFromPageName : '';
    if (customSlugValue === undefined) {
        return constants_1.pageTypes.includes(pageType) ? pageType : fallbackSlug || '';
    }
    return !customSlugValue
        ? (fallbackSlug === null || fallbackSlug === void 0 ? void 0 : fallbackSlug.toLowerCase()) || ''
        : customSlugValue.toLocaleLowerCase();
};
exports.generateSlug = generateSlug;
var buildSearchParams = function (term) {
    var encodedTerm = encodeURIComponent(term);
    var searchParams = new URLSearchParams({ terms: encodedTerm });
    return "?".concat(searchParams.toString());
};
exports.buildSearchParams = buildSearchParams;
var getEventProperties = function (currentRoute, storeCode, localeValue, extraProperties) {
    var eventProperties = (0, exports.extractEventProperties)(currentRoute, storeCode, localeValue);
    var slug = (0, exports.generateSlug)(eventProperties, currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.name);
    var term = eventProperties === null || eventProperties === void 0 ? void 0 : eventProperties.term;
    var search = (0, exports.buildSearchParams)(term !== null && term !== void 0 ? term : '');
    var store = eventProperties.store, locale = eventProperties.locale, category_name = eventProperties.category_name, subcategory_name = eventProperties.subcategory_name, page_type = eventProperties.page_type;
    var result = __assign(__assign({ store: store, locale: locale, slug: slug, page_type: page_type, category_name: category_name }, extraProperties), { subcategory_name: subcategory_name });
    if (term) {
        result.search = search;
    }
    var filteredResult = Object.fromEntries(Object.entries(result).filter(function (_a) {
        var value = _a[1];
        return value !== undefined;
    }));
    return filteredResult;
};
exports.getEventProperties = getEventProperties;
//# sourceMappingURL=eventUtils.js.map